
import {Vue, Component} from 'vue-property-decorator';

@Component({})
export default class CreditListLayout extends Vue {
    private goUrl(url: string) {
        this.$router.push({ path: url });
    }
}
